import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { FileStore, FileState } from './file.store';

@Injectable()
export class FileQuery extends QueryEntity<FileState> {
  constructor(protected store: FileStore) {
    super(store);
  }
}
